<p-panel class="secondary-panel">
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center flex-fill">
      <span>Employer Details</span>
    </div>
  </ng-template>
  <form [formGroup]="form" class="d-flex w-100 flex-column mb-3">
    <div class="row mb-2">
      <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'employmentTypeCurrent' | qaSlug">
        <div class="radiobutton-container">
          <p-radiobutton
            name="employmentType"
            formControlName="employmentType"
            [value]="1"
            [inputId]="autoIdPrefix + 'employmentTypeCurrent' | qaSlug"
          />
          <label class="control-label" [for]="autoIdPrefix + 'employmentTypeCurrent' | qaSlug">Current</label>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'employmentTypePrevious' | qaSlug">
        <div class="radiobutton-container">
          <p-radiobutton
            name="employmentType"
            formControlName="employmentType"
            [value]="0"
            [inputId]="autoIdPrefix + 'employmentTypePrevious' | qaSlug"
          />
          <label class="control-label" [for]="autoIdPrefix + 'employmentTypePrevious' | qaSlug">Previous</label>
        </div>
      </div>
    </div>
    <hr />
    <div class="row mb-2">
      <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 form-group" [attr.automation-id]="'isPrimary' | qaSlug">
        <div class="checkbox-container">
          <p-checkbox [binary]="true" formControlName="isPrimary" [inputId]="'isPrimary' | qaSlug" />
          <label [for]="'isPrimary' | qaSlug">Is Primary</label>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'isSelfEmployment' | qaSlug">
        <div class="checkbox-container">
          <p-checkbox [binary]="true" class="centered" formControlName="isSelfEmployment" inputId="isSelfEmployment" />
          <label class="control-label">Self-Employment</label>
        </div>
        @if (form.get('isSelfEmployment').value) {
          <div class="offset-sm-1 form-group" [attr.automation-id]="'ownershipShare' | qaSlug">
            <div class="radiobutton-container mx-1">
              <p-radiobutton name="ownershipShare" formControlName="ownershipShare" [value]="1" inputId="ownershipShareLessThan" />
              <label class="control-label" for="ownershipShareLessThan">≥ 25%</label>
            </div>
            <div class="radiobutton-container">
              <p-radiobutton class="mx-1" name="ownershipShare" formControlName="ownershipShare" [value]="2" inputId="ownershipShareGreaterThan" />
              <label class="control-label" for="ownershipShareGreaterThan">< 25%</label>
            </div>
          </div>
        }
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix + 'isSpecialRelationship' | qaSlug">
        <div class="checkbox-container">
          <p-checkbox
            [binary]="true"
            class="centered"
            formControlName="isSpecialRelationship"
            [inputId]="autoIdPrefix + 'isSpecialRelationship' | qaSlug"
          />
          <label [for]="autoIdPrefix + 'isSpecialRelationship' | qaSlug">Employed by Family or Party</label>
        </div>
      </div>
    </div>
    <hr />
    <div class="row mb-2">
      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 form-group" [attr.automation-id]="autoIdPrefix + 'employerName' | qaSlug">
        <label class="control-label">
          Employer Name
          <span class="color-danger">*</span>
        </label>
        <input
          data-private
          id="employerName"
          pInputText
          class="txt-box form-control"
          type="text"
          formControlName="employerName"
          maxlength="50"
          (blur)="onBlurEmployerName()"
        />
        <cmg-validator-messages [control]="form.get('employerName')" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 form-group">
        <label class="control-label"> Position/Title </label>
        <input data-private id="position" pInputText class="txt-box form-control" type="text" formControlName="position" maxlength="50" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'dateFrom' | qaSlug">
        <label class="control-label">Start Date <span class="color-danger">*</span></label>
        <p-datepicker
          id="fromDate"
          styleClass="w-100"
          formControlName="fromDate"
          [minDate]="minEmploymentDate"
          [maxDate]="todaysDate"
          [readonlyInput]="false"
          [defaultDate]="todaysDate"
          [showIcon]="true"
          cmg-date-mask
          appendTo="body"
          placeholder="MM/DD/YYYY"
          [baseZIndex]="dateTimePickerCalendarZIndex"
        />
      </div>
      @if (form.get('employmentType').value === EmploymentStatus.SecondaryCurrent) {
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'dateTo' | qaSlug">
          <label class="control-label">End Date</label>
          <input pInputText class="txt-box form-control" type="text" value="Present" disabled />
        </div>
      }
      @if (form.get('employmentType').value === EmploymentStatus.Former) {
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'dateTo' | qaSlug">
          <label class="control-label">End Date</label>
          <p-datepicker
            id="toDate"
            formControlName="toDate"
            [minDate]="minEmploymentDate"
            [maxDate]="todaysDate"
            [readonlyInput]="false"
            [defaultDate]="todaysDate"
            [showIcon]="true"
            cmg-date-mask
            appendTo="body"
            placeholder="MM/DD/YYYY"
            [baseZIndex]="dateTimePickerCalendarZIndex"
          />
        </div>
      }
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'businessPhone' | qaSlug">
        <label class="control-label">Business Phone</label>
        <p-inputMask
          data-private
          class="w-100"
          mask="(999) 999-9999"
          [autoClear]="true"
          [unmask]="true"
          formControlName="businessPhone"
          placeholder="(xxx) xxx-xxxx"
        />
      </div>
    </div>
    <div class="row mb-2">
      <hr />
      <div class="col-12 col-sm-8 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'street' | qaSlug">
        <label class="control-label">Street Address</label>
        <input data-private class="txt-box form-control" type="text" pInputText formControlName="street" maxlength="50" />
      </div>
      <div class="col-12 col-sm-4 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'aptSuiteOther' | qaSlug">
        <label class="block control-label">Apt/Suite/Other</label>
        <div class="d-flex flex-wrap align-items-center">
          <input data-private class="txt-box form-control" type="text" pInputText formControlName="aptSuiteOther" maxlength="50" />
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'zip' | qaSlug">
        <label class="control-label">Zip</label>
        <cmg-form-control-zip-code formControlName="zip" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'city' | qaSlug">
        <label class="control-label">City</label>
        <input data-private class="txt-box form-control" pInputText type="text" formControlName="city" maxlength="50" />
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix + 'state' | qaSlug">
        <label class="control-label">State</label>
        <p-select appendTo="body" data-private class="w-100" [options]="states" formControlName="state" [optionLabel]="'name'" [optionValue]="'id'" />
      </div>
    </div>
    @if (employmentType === 0) {
      <div class="row mb-2">
        <hr />
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-3 form-group d-flex flex-column">
          <label class="control-label">Previous Monthly Income</label>
          <p-inputNumber
            class="flex-full-width"
            formControlName="monthlyIncome"
            placeholder="$0.00"
            currency="USD"
            mode="currency"
            locale="en-US"
            [max]="99999999999.99"
            maxlength="20"
            id="{{ 'monthlyIncome-' + k + '-employment-' + employment?.employmentId }}"
          />
        </div>
      </div>
    }
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group" [attr.automation-id]="autoIdPrefix + 'notes' | qaSlug">
      <label class="control-label">Notes</label>
      <input data-private id="notes" pInputText class="txt-box form-control" type="text" formControlName="notes" maxlength="200" />
      <cmg-validator-messages [control]="form.get('notes')" />
    </div>
  </form>
</p-panel>
@if (employmentType !== 0) {
  <p-panel class="secondary-panel">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-between align-items-center flex-fill">
        <span>Income from Employer</span>
      </div>
    </ng-template>
    <p-table
      #dt
      class="expenses-table stack"
      styleClass="mb-3"
      dataKey="incomeId"
      editMode="row"
      [columns]="incomesGridColumns"
      [value]="employmentIncomes"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
              {{ col.header }}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            <div class="d-flex justify-content-center align-items-center title-text">No records found</div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-editing="editing" let-rowData let-columns="columns" let-ri="rowIndex">
        <tr editing="true" [pEditableRow]="rowData">
          @for (col of columns; track col) {
            <td [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
              <span class="p-column-title fw-bold">{{ col.header }}</span>
              <div>
                @switch (col.field) {
                  @case ('index') {
                    <div>{{ ri + 1 }}</div>
                  }
                  @case ('incomeId') {
                    <div style="display: none"></div>
                  }
                  @case ('incomeType') {
                    <div>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-select
                            class="w-100"
                            [options]="incomeTypes"
                            [(ngModel)]="rowData[col.field]"
                            [optionLabel]="'value'"
                            [optionValue]="'id'"
                            appendTo="body"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ rowData[col.field] | toNameOrValue: incomeTypes }}
                        </ng-template>
                      </p-cellEditor>
                    </div>
                  }
                  @case ('incomeFrequencyType') {
                    <div>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-select
                            class="w-100"
                            [options]="frequencyOptions"
                            [(ngModel)]="rowData[col.field]"
                            [optionLabel]="'name'"
                            [optionValue]="'value'"
                            appendTo="body"
                            (onChange)="calculateMonthlyAmount(rowData)"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          <ng-container>
                            {{ rowData[col.field] | toNameOrValue: frequencyOptions : 'name' }}
                          </ng-container>
                        </ng-template>
                      </p-cellEditor>
                    </div>
                  }
                  @case ('hoursPerWeek') {
                    <div>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber
                            class="flex-full-width"
                            [(ngModel)]="rowData[col.field]"
                            placeholder="0"
                            locale="en-US"
                            (ngModelChange)="calculateMonthlyAmount(rowData)"
                            [maxFractionDigits]="2"
                            maxlength="7"
                            mode="decimal"
                            data-private
                            [disabled]="rowData.incomeFrequencyType !== 6"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          <span>{{ rowData[col.field] | currency }}</span>
                        </ng-template>
                      </p-cellEditor>
                    </div>
                  }
                  @case ('incomeRate') {
                    <div>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber
                            class="flex-full-width"
                            [(ngModel)]="rowData[col.field]"
                            placeholder="0.00"
                            locale="en-US"
                            (ngModelChange)="calculateMonthlyAmount(rowData)"
                            mode="currency"
                            data-private
                            currency="USD"
                            [maxFractionDigits]="2"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          <span>{{ rowData[col.field] | currency }}</span>
                        </ng-template>
                      </p-cellEditor>
                    </div>
                  }
                  @case ('amount') {
                    <div>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber
                            class="flex-full-width"
                            [(ngModel)]="rowData[col.field]"
                            placeholder="0"
                            locale="en-US"
                            maxlength="25"
                            [maxFractionDigits]="2"
                            disabled
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          <span>{{ rowData[col.field] | currency }}</span>
                        </ng-template>
                      </p-cellEditor>
                    </div>
                  }
                  @case ('actionsCol') {
                    <div>
                      <div class="d-flex float-right">
                        <div>
                          @if (!editing) {
                            <p-button pInitEditableRow type="button" icon="pi pi-pencil" />
                          }
                        </div>
                        <div>
                          <p-button
                            type="button"
                            severity="danger"
                            icon="pi pi-trash"
                            data-toggle="tooltip"
                            title="delete"
                            iconPos="left"
                            (click)="onRowDelete(ri, rowData.incomeId)"
                          />
                        </div>
                      </div>
                    </div>
                  }
                  @default {
                    <div>{{ col.field }}: {{ rowData[col.field] }}</div>
                  }
                }
              </div>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
    <ng-container>
      <div class="d-flex">
        <button pButton severity="secondary" size="small" class="mb-3" (click)="onAddIncome()">
          <i class="pi pi-plus-circle me-3"> </i>
          <span>Add Income</span>
        </button>
      </div>
    </ng-container>
  </p-panel>
}
<div class="row">
  <div class="col-md-12 mt-3 d-flex justify-content-end">
    <button pButton type="button" severity="secondary" class="mx-1" (click)="onCancelClicked()">Cancel</button>
    <button pButton type="button" class="mx-1" (click)="addOrUpdate()">Done</button>
  </div>
</div>
